import { Component, OnInit } from "@angular/core";

import { AccountInfoService } from "../../common/account-info/account-info-service"; // TODO rm once mfa feature is enabled for all accounts
import { BrowserTitleService } from "../../common/browser-title/browser-title.service";
import { AccountInfo } from "../../models";
import { AuthenticationService } from "../../common/authentication/authentication.service";

@Component({
	selector: "sdp-settings",
	templateUrl: "./settings.component.html",
	styleUrls: ["_settings-css.scss"]
})

export class SettingsComponent implements OnInit {
	public accountInfo: AccountInfo | undefined;
	public isAdmin = false;

	constructor(
		private accountInfoService: AccountInfoService, // TODO rm once mfa feature is enabled for all accounts
		private titleService: BrowserTitleService,
		private authenticationService: AuthenticationService
	) { }

	public async ngOnInit() {
		this.titleService.setTitle("settings.title");
		this.accountInfo = await this.accountInfoService.getAccountInfo(); // TODO rm once mfa feature is enabled for all accounts
		const user = this.authenticationService.getCurrentUser();
		if (!!user) {
			this.isAdmin = user.admin;
		}
	}
}
